import * as yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const requiredValueObject = (fieldName) =>
    yup
        .mixed()
        .test(fieldName, `${fieldName} is required`, (val) => {
            if (!val) return false;

            if (typeof val === "string") return val.trim().length > 0;

            if (typeof val === "object" && val.value) {
                return String(val.value).trim().length > 0;
            }

            return false;
        });

export const admissionSchema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),

  phone: yup.string()
  .required("Phone number is required")
  .test(
    "valid-phone",
    "Invalid phone number",
    (value) => {
      if (!value) return false;
       const phone = parsePhoneNumberFromString("+" + value);
      return phone?.isValid() || false;
    }
  ),
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),

  universityId: requiredValueObject("University"),
  courseNameId:requiredValueObject("Course"),
  specializationNameId:requiredValueObject("Specialization"),
  paymentStatus: yup.string().required("Payment status is required"),
  receipt: yup.string().required("Receipt is required"),
  courseFee: yup.object().shape({
    amount: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Amount must be a valid number (max 2 decimals)")
      .required("Course fee amount is required"),
    currency: yup.string().required("Currency is required"),
  }),

  paidAmt: yup.object().shape({
    amount: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Amount must be a valid number (max 2 decimals)")
      .required("Paid amount is required"),
    currency: yup.string().required("Currency is required"),
  }),
});
